import { render, staticRenderFns } from "./detail-tracking.vue?vue&type=template&id=7630702a&"
import script from "./detail-tracking.vue?vue&type=script&lang=js&"
export * from "./detail-tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports